import { useMemo } from "react";
import { IActionPlan } from "entities/RCA/ActionPlanEntity/ActionPlanEntityInterfaces";
import { useActionPlansEditionContext } from "../../context/ActionPlansEditionContext";

interface IUseActionPlanInlineEditRowResult {
    isEditing: boolean;
    isSaving: boolean;
    isNameValid: boolean;
    startEdit: () => void;
    saveEdit: () => void;
    cancelEdit: () => void;
}

export const useActionPlanInlineEditRow = (row: IActionPlan): IUseActionPlanInlineEditRowResult => {
    const { edit, isSavingInline, handleStartInlineEdit, handleSaveInlineEdit, handleCancelInlineEdit } =
        useActionPlansEditionContext();

    const existingEdition = useMemo(() => edit.findIndex((e) => e.id === row.action_plan_id), [edit, row]);
    const isEditing = existingEdition !== -1;
    const isSaving = isSavingInline && isEditing;

    const editedName = useMemo(
        () => (isEditing ? edit[existingEdition]?.changes?.name ?? row.name : row.name),
        [edit, existingEdition, isEditing, row.name],
    );

    const isNameValid = !!editedName && editedName.trim().length > 0;

    const startEdit = () => {
        handleStartInlineEdit(row);
    };

    const saveEdit = () => {
        handleSaveInlineEdit(row);
    };

    const cancelEdit = () => {
        handleCancelInlineEdit(row.action_plan_id);
    };

    return {
        isEditing,
        isSaving,
        isNameValid,
        startEdit,
        saveEdit,
        cancelEdit,
    };
};


